'use client'
import { useFormStatus } from "react-dom";
import {useState, useMemo} from 'react';
import { Loader2, Check } from "lucide-react"

const SubmitButton = () => {
    const { pending, data } = useFormStatus();
    const [email, setEmail] = useState(null);

    useMemo(() => {
      if (pending) {
        setEmail(data?.get('email'))
      }
    }, [pending, data]);
    
    return (
        <button disabled={pending} className='btn btn-neutral p-2 w-28 flex justify-center items-center join-item'>
          {pending ? 
            <Loader2 className="h-4 w-4 animate-spin" />  
          : 
          <>
          {
            email ? <Check className="h-4 w-4" /> : 'Subscribe'
          }
          </>
          }
        </button>
    )
}

export default SubmitButton;